import bind from './bind'

bind()
